import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1 } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerEase(Power4);
gsap.registerEase(Power1);

export default (els) => {
	Array.prototype.forEach.call(els, (el) => {
		// console.log(el);
		// console.log(scroller);

		// gsap.set(el, {
		// 	yPercent: -100
		// });

		//const revealNavigation = gsap.to(el, { yPercent: 0, paused: true, duration: 1, ease: Power1.easeOut });

		//revealNavigation.play();
		let showNavigation, initNavigation;

		// showNavigation = gsap
		// 	.to(el, {
		// 		yPercent: 0,
		// 		paused: false,
		// 		duration: 0.85,
		// 		delay: 1,
		// 		ease: 'power1.inOut',
		// 		onComplete: () => {

		// 			let previousScrollPosition = 0;



		// 			let toggleNavigation = gsap.to(el, {
		// 				yPercent: -100,
		// 				paused: true,
		// 				duration: 0.55,
		// 				ease: 'power1.inOut'
		// 			});

		// 			const isScrollingDown = () => {

		// 				let goingDown = false;

		// 				let scrollPosition = window.pageYOffset;

		// 				if (scrollPosition > previousScrollPosition) {
		// 					goingDown = true;
		// 				}

		// 				previousScrollPosition = scrollPosition;

		// 				return goingDown;
		// 			};

		// 			const handleScroll = () => {
		// 				if (isScrollingDown()) {
		// 					toggleNavigation.play();
		// 				} else {
		// 					toggleNavigation.reverse();
		// 				}
		// 			};

		// 			const scrollThrottle = _.throttle(handleScroll, 100);


		// 			window.addEventListener('scroll', scrollThrottle);


		// 		}
		// 	});

		// showNavigation.play();









	});
};
